import { useSelector } from 'react-redux'

export const useIsDarkMode = () => {
    // @ts-expect-error redux store is not typed properly
    const isDarkMode = useSelector((state) => state?.userRecord?.isDarkMode ?? true)

    return isDarkMode === true
}
